import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

const Wrapper = styled.div`
    display: block;
    text-align: ${({ align }) => align};
    padding-top: ${({ paddingTop }) => paddingTop ?? "auto"};
`;

const UnderlineTitle = ({
    children,
    lang,
    align = "left",
    light = false,
    element = "span",
    noMarginBottom = false,
    smallMarginBottom = false,
    titleId = "",
    paddingTop = null,
}) => {
    const Tag = element;

    const StyledTag = styled(Tag)`
        display: inline-block;
        color: ${({ theme }) =>
            light
                ? theme.colors.typography.defaultDarkBackground
                : theme.colors.typography.defaultLightBackground};
        font-weight: 400;
        font-size: 2rem;
        margin-bottom: ${({ noMarginBottom, smallMarginBottom }) =>
            noMarginBottom ? `0` : smallMarginBottom ? `.8em` : `1.65em`};
        line-height: 1.2;
        letter-spacing: -0.0075em;
        padding-bottom: 10px;
        border-bottom: ${({ theme }) => `3px solid ${theme.palette.teal}`};
    `;

    return (
        <Wrapper {...{ align, lang, paddingTop }}>
            <StyledTag {...{ noMarginBottom, smallMarginBottom }} id={titleId}>
                {children}
            </StyledTag>
        </Wrapper>
    );
};

UnderlineTitle.propTypes = {
    align: PropTypes.string,
    children: PropTypes.node.isRequired,
    light: PropTypes.bool,
    element: PropTypes.oneOf(["span", "h2"]),
    noMarginBottom: PropTypes.bool,
    smallMarginBottom: PropTypes.bool,
    titleId: PropTypes.string,
    paddingTop: PropTypes.string,
};

export default UnderlineTitle;
